<template>
  <v-row justify="center">
    <v-dialog :value="value" @input="$emit('input')" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('toolbar.idioma') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12">
                <v-list class="v-list">
                    <v-list-item-group color="primary">
                        <v-list-item v-for="(idioma, i) in idiomas" :key="i">
                            <v-list-item-content @click="cambiarIdioma(idioma.clave)">
                                <v-list-item-title v-text="idioma.descripcion"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="$emit('input')">{{ $t('selectIdioma.cerrar') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    value: Boolean
  },
  data () {
    return {
      idiomas: [
        {
          clave: 'es',
          descripcion: this.$t('es')
        },
        {
          clave: 'en',
          descripcion: this.$t('en')
        },
        {
          clave: 'eu',
          descripcion: this.$t('eu')
        }
      ],
      codigosIdiomas: [
        {
          cod_idioma2: 'es',
          cod_idioma: 'spa'
        },
        {
          cod_idioma2: 'en',
          cod_idioma: 'eng'
        },
        {
          cod_idioma2: 'eu',
          cod_idioma: 'eus'
        }
      ],
    }
  },
  computed: {
  },
  methods: {
    ...mapActions({
      guardarIdiomaUsuario: 'configuracion/guardarIdiomaUsuario',
    }),
    async cambiarIdioma (idioma) {
      this.$i18n.locale = idioma
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false
      })
      localStorage.setItem('i18n', idioma)
      await this.guardarIdiomaUsuario(this.getCodIdioma(idioma))
      const usuario = JSON.parse(localStorage.getItem('usuario'))
      usuario.idioma = this.getCodIdioma(idioma)
      localStorage.setItem('usuario', JSON.stringify(usuario))
      this.loader.hide()
      this.$router.go()
    },
    getCodIdioma(cod_idioma_iso) {
      return this.codigosIdiomas.map(idioma => (idioma.cod_idioma2 === cod_idioma_iso) ? idioma.cod_idioma : '').filter(value => value !== "")[0]
    },
  }
}
</script>

<style scoped>
</style>
